@if (displayMessageBanner) {
  <message-banner
    [config]="messageBannerConfig"
    (actionClicked)="state.showBanner = false"
  ></message-banner>
}

@if (state && formGroup) {
  <card
    [config]="{
      hideSubHeader: true,
    }"
    class="calculate-premium-card card"
    [ngClass]="{ 'is-open': state.open }"
  >
    <header title>
      <h6 class="t-bold" data-test-id="premiumCardHeaderTitle">
        {{ config?.header?.title }}
      </h6>
      @if (state.started) {
        <div
          class="calculate-premium-card__toggle toggle"
          (click)="state.open = !state.open"
        >
          @if (state.open) {
            <a class="t-link" data-test-id="premiumCardCloseToggleLink">
              <i
                class="icon icon--small"
                data-test-id="premiumCardCloseToggleIcon"
                >{{ config.header.toggle.close.icon }}</i
              ></a
            >
          }
          @if (!state.open) {
            <a class="t-link" data-test-id="premiumCardEditToggleLink">
              {{ config.header.toggle.edit.copy }}
              <i
                class="icon icon--small"
                data-test-id="premiumCardEditToggleIcon"
                >{{ config.header.toggle.edit.icon }}</i
              >
            </a>
          }
        </div>
      }
    </header>
    @if (state.open) {
      <div body [ngClass]="{ isOpen: state.open }">
        <p data-test-id="premiumCardBodyText">{{ config?.body }}</p>
        @if (config.showLearnMore) {
          <div class="t-link learn-more" (click)="toggleModal()">
            <i
              class="icon icon--small"
              data-test-id="premiumCardLearnMoreIcon"
              >{{ config.learnMoreConfig?.icon }}</i
            >
            {{ config.learnMoreConfig.label }}
          </div>
        }
        @if (!state.started) {
          <div class="btn-container u-flex u-alignCenter">
            <zip-button
              [level]="config.button.level"
              [content]="config.button.content"
              (zipButtonClicked)="state.started = true"
              data-test-id="premiumCardStartButton"
            >
            </zip-button>
          </div>
        }
        @if (state.started && state.open) {
          <div class="form-container">
            <form-group
              [form]="formGroup"
              [configs]="config.controls"
              data-test-id="premiumCardFormGroup"
            >
            </form-group>
          </div>
        }
      </div>
    }
    @if (state.started && state.open) {
      <div footer>
        <div class="footer-content u-flex u-justifyEnd">
          <zip-button
            [disabled]="!formGroup.valid"
            [level]="config.footer.button.level"
            [content]="config.footer.button.content"
            (zipButtonClicked)="onSubmit.emit(); state.open = false"
            data-test-id="premiumCardSubmitButton"
          >
          </zip-button>
        </div>
      </div>
    }
  </card>
}

<modal [config]="learnMoreModalConfig" [condition]="showModal">
  <div body>
    @for (
      paragraph of config.learnMoreConfig?.modalParagraphs;
      track paragraph;
      let i = $index
    ) {
      <div class="modal__body__primary-text">
        <p data-test-id="'premiumCardModalParagraph' + i">{{ paragraph }}</p>
      </div>
    }
  </div>
  <div footer>
    <zip-button
      class="close-button"
      [config]="{ level: 'high', content: 'Close' }"
      (zipButtonClicked)="toggleModal()"
      data-test-id="premiumCardCloseModalButton"
    >
    </zip-button>
  </div>
</modal>
